module.exports = __webpack_public_path__ + "static/media/no-experiment-results.262ac2fc.svg";